// Палитра аватарок учеников — мягкие «средние» тона (не резкие, но белая
// иконка на них читается). Много разных, чтобы у учеников не повторялись.
export const AVATAR_COLORS = [
  '#EF7E7E', // коралл
  '#F0965A', // оранжевый
  '#D9A32E', // золотой
  '#86BF54', // лайм
  '#4FC08D', // зелёный
  '#37B8A4', // бирюза
  '#45AFD6', // голубой
  '#5E9CEA', // синий
  '#7C86E6', // индиго
  '#A07BE6', // фиолетовый
  '#BE6FD9', // сиреневый
  '#E070B8', // маджента
  '#EC6F92', // роза
  '#E8806A', // терракота
  '#C6996A', // мокко
  '#7E93B0', // сланец
];

export const avatarColor = (id) => AVATAR_COLORS[Math.abs(id || 0) % AVATAR_COLORS.length];

// Затемнение цвета к чёрному на amt% (для читаемого текста/инициалов)
const darken = (hex, amt = 60) => {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex || '');
  const n = m ? parseInt(m[1], 16) : 0;
  const p = 1 - amt / 100;
  const r = Math.round(((n >> 16) & 255) * p);
  const g = Math.round(((n >> 8) & 255) * p);
  const b = Math.round((n & 255) * p);
  return '#' + [r, g, b].map(x => x.toString(16).padStart(2, '0')).join('');
};

// Цвет инициалов для аватарки этого ученика (не используется — оставлен для совместимости)
export const avatarText = (id) => darken(avatarColor(id), 62);

// Цвет иконки в аватарке — мягкий тон того же цвета (не используется, оставлен для совместимости)
export const avatarIconColor = (id) => darken(avatarColor(id), 42);

// Иконка-человечек вместо инициалов — белая, на цветном фоне
export const AvatarIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#fff"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M19 21v-1a5 5 0 0 0-5-5h-4a5 5 0 0 0-5 5v1" />
    <circle cx="12" cy="8" r="4" />
  </svg>
);
